import React, { ReactNode } from 'react';
import './badge.css';

interface BadgeProps {
  type: string;
  children: ReactNode;
}

function Badge({ type, children }: BadgeProps) {
  return (
    <div className={`badge-custom ${type}`}>
      {children}
    </div>
  );
}

export default Badge;